<template>
  <div class="obs_container obs_experience">
    <h2 class="obs_heading typo-h2 text-light-high text-center">{{ $t("onboardingStep.describes.title") }}</h2>
    <div class="obs_body">
      <div class="col-5 col-sm-8 mx-auto">
        <div class="obs_body-describes row">
          <div class="col-6">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.describes.option1.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option1.key'))" :label="$t('onboardingStep.describes.option1.text')" :value="$t('onboardingStep.describes.option1.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-6">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.describes.option2.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option2.key'))" :label="$t('onboardingStep.describes.option2.text')" :value="$t('onboardingStep.describes.option2.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.describes.option3.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option3.key'))" :label="$t('onboardingStep.describes.option3.text')" :value="$t('onboardingStep.describes.option3.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.describes.option4.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option4.key'))" :label="$t('onboardingStep.describes.option4.text')" :value="$t('onboardingStep.describes.option4.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.describes.option5.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option5.key'))" :label="$t('onboardingStep.describes.option5.text')" :value="$t('onboardingStep.describes.option5.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.describes.option6.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option6.key'))" :label="$t('onboardingStep.describes.option6.text')" :value="$t('onboardingStep.describes.option6.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="obs_describes-item pdl20 fl-col" :class="{ 'padding_expand active': specifySelect }">
              <GpRadioButton @change="selectItem($t('onboardingStep.describes.option7.key'))" :label="$t('onboardingStep.describes.option7.text')" :value="$t('onboardingStep.describes.option7.key')" v-model="optionsValue" />
              <TransitionExpand>
                <textarea ref="contentTextArea" :class="{ showing: specifySelect, invalid: isSpecifyBlank }" type="text" @keyup="checkBlankText" v-model="specifyValue" :placeholder="$t('onboardingStep.describes.option7Placholder')" />
              </TransitionExpand>
              <span class="obs_invalid typo-body2" v-if="isSpecifyBlank && specifySelect">{{ $t("onboardingStep.describes.invalidMessage") }}</span>
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="obs_describes-item --selection">
              <label class="typo-body1 typo-semibold">{{ $t("onboardingStep.describes.selectLabel") }}</label>
              <BaseSelect positioning v-model="industryValue" :options="industryOptions" animate />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="obs_footer" :class="{ 'mt-100':!specifySelect, 'mt-44': specifySelect }"> -->
    <div class="obs_footer">
      <button type="button" class="obs_btn disabled" v-if="!isFormValid" v-popover:tooltip.top="$t('onboardingStep.describes.tooltip')">{{ $t("onboardingStep.describes.button") }}</button>

      <button type="button" class="obs_btn" v-if="isFormValid" @click="submitForm">{{ $t("onboardingStep.describes.button") }}</button>
    </div>
  </div>
</template>

<script>
import { GpRadioButton } from "@/core/shared/GpForms";
import { mapMutations, mapState } from "vuex";
import { mutations } from "@/store/onboarding/types.js";
import obsLocalData from "@/utils/obsLocalData.js";
export default {
  name: "Describes",
  components: {
    GpRadioButton
  },
  props: {
    userName: String,
    step: Number
  },
  data() {
    return {
      testValue: true,
      optionsValue: [],
      industryValue: "",
      specifySelect: false,
      specifyValue: "",
      isSpecifyBlank: false,
      startTime: Date,
      endTime: Date,
      currentSelect: "", 
    };
  },
  computed: {
    ...mapState("onboarding", {
      describes: state => state.describes
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    isFormValid() {
      return this.checkFormValid();
    },
    industryOptions() {
      const options = ["arts", "fashion", "accessories", "baby", "electronics", "food", "home", "beauty", "health", "sports", "toys", "animals", "phones", "books", "people", "tools", "automotive", "computer", "business", "others"];
      return options.map(x => ({
        value: x,
        text: this.$t(`onboardingStep.describes.industry.${x}`)
      }))
    }
  },
  created() {
    setTimeout(() => {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      if (obsLocalData.check(shopifyDomain)) {
        const lastSurvey = obsLocalData.get(shopifyDomain);
        if (lastSurvey && lastSurvey.store && lastSurvey.store.describes) {
          this.initData(lastSurvey.store.describes);
        }
      } else {
        this.initData(this.describes);
      }
    }, 300);
    this.startTime = new Date().getTime();
  },
  methods: {
    ...mapMutations("onboarding", {
      obsDescribes: mutations.OBS_DESCRIBES
    }),
    submitForm() {
      this.endTime = new Date().getTime();
      const timeCounter = this.endTime - this.startTime;
      if (this.specifySelect && !this.specifyValue) {
        this.isSpecifyBlank = true;
        return;
      } else {
        const describes = this.optionsValue;
        // const describes = this.specifySelect ? ["others"].concat(this.optionsValue) : this.optionsValue;
        const dataStep = {
          business: describes,
          industry: this.industryValue,
          specifySelect: this.specifySelect,
          specifyValue: this.specifyValue,
          time: timeCounter,
          data: describes.join()
        };
        this.obsDescribes(dataStep);
        this.$emit("next", this.step);
        const shopifyDomain = this.shopInfo.shopifyDomain;
        obsLocalData.set(dataStep, "describes", shopifyDomain);
        obsLocalData.set(this.step, "currentStep", shopifyDomain);

        this.nextStep();
      }
    },
    checkBlankText() {
      if (this.specifySelect && this.specifyValue) {
        this.isSpecifyBlank = false;
      } else {
        this.isSpecifyBlank = true;
      }
    },
    nextStep() {
      this.$emit("next", this.step);
    },
    checkFormValid() {
      let result = false;
      const specifyCheck = this.specifySelect && this.specifyValue;
      const optionCheck = this.optionsValue.length;
      const describesCheck = specifyCheck || optionCheck;
      const industryCheck = this.industryValue;
      if (describesCheck && industryCheck) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    initData(describes) {
      this.optionsValue = describes.business;
      this.industryValue = describes.industry;
      this.specifyValue = describes.specifyValue;
      this.specifySelect = describes.specifySelect;
    },
    selectItem(value) {
      this.currentSelect = value;
      if (value === this.$t("onboardingStep.describes.option7.key")) {
        this.specifySelect = true;
        setTimeout(() => {
          const textarea = this.$refs.contentTextArea;
          textarea.focus();
        }, 200);
      } else {
        this.specifyValue = "";
        this.specifySelect = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.obs_experience {
  width: 100%;
  height: 100%;
}
</style>
